import { render } from "./Radio.vue?vue&type=template&id=5c48de8c&ts=true"
import script from "./Radio.vue?vue&type=script&lang=ts"
export * from "./Radio.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__